import { useState } from 'react';
import { Combobox, IdentifiedOption } from '@backstage/ui';
import styles from './DropdownField.module.css';

// Local state for a DropdownField.
export const useDropdownField = (initialValue: string | null = null) => {
  const [value, setValue] = useState<string | null>(initialValue);
  return { value, setValue };
};

interface DropdownFieldProps {
  name: string;
  placeholder: string;
  options: string[] | IdentifiedOption[];
  field: ReturnType<typeof useDropdownField>;
  isInvalid?: boolean;
}

export const DropdownField = ({
  name,
  placeholder,
  options,
  field,
  isInvalid,
}: DropdownFieldProps) => {
  return (
    <Combobox
      name={name}
      aria-label={placeholder}
      className={styles.comboboxField}
      placeholder={placeholder}
      options={options.map(option => typeof option === "string" ? ({ id: option, label: option }) : option)}
      selectedKey={field.value}
      onSelectionChange={key => field.setValue((key?.toString() as string | null) ?? null)}
      isInvalid={isInvalid}
    />
  );
};
